// Appends the location search parameters (query string) on to the index location for TinCan/xAPI support
export default (pathToIndex: string): string =>
  `${pathToIndex}${location.search}`;
